export const PLOTLY_THEME_DEFAULTS = {
  margin: 50,
  // Extra top-margin floor so the title + a top-anchored legend have room; paired with title.automargin, which
  // keeps the legend below the title. The bigger floor stops the title from wedging the top edge on re-render.
  marginTop: 70,
  legendMinWidth: 300,
  textColor: "#333333",
  textSecondaryColor: "rgba(0, 0, 0, 0.7)",
  dividerColor: "rgba(0, 0, 0, 0.12)",
  bgColor: "#ffffff",
}

// Dark-scheme chrome fallbacks (mirror the app's darkPalette) — used ONLY when the active scheme's palette
// (theme.colorSchemes[scheme].palette) can't be resolved (e.g. tests); prod reads the resolved theme colors.
export const PLOTLY_THEME_DEFAULTS_DARK = {
  textColor: "#f0f0f0",
  textSecondaryColor: "rgba(255, 255, 255, 0.72)",
  dividerColor: "rgba(255, 255, 255, 0.09)",
  bgColor: "#181818",
}

export const AXIS_LAYOUT_KEY_PATTERN = /^(xaxis|yaxis)\d*$/
